/**
 * LanguageSelector - Dropdown for language selection
 *
 * Uses Select component with custom trigger (button-square with flag).
 * NOTE: Uses position: relative. Wrap in FloatingControls for fixed positioning.
 *
 * @example
 * <FloatingControls position="top-left">
 *   <MusicWidget />
 *   <LanguageSelector />
 * </FloatingControls>
 */

import Select from '@components/ui/general/Select';
import useTranslationStore from '@/store/useTranslationStore';
import './LanguageSelector.css';

// Language options with flags
const LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English', flag: '\u{1F1FA}\u{1F1F8}' },
  { value: 'es', label: 'Espanol', flag: '\u{1F1EA}\u{1F1F8}' },
  { value: 'pt', label: 'Portugues', flag: '\u{1F1E7}\u{1F1F7}' },
];

export default function LanguageSelector() {
  const locale = useTranslationStore((state) => state.locale);
  const setLocale = useTranslationStore((state) => state.setLocale);
  const isLoading = useTranslationStore((state) => state.isLoading);

  const handleChange = async (e) => {
    const newLocale = e.target.value;
    if (newLocale === locale || isLoading) return;
    await setLocale(newLocale);
  };

  return (
    <div className="language-selector">
      <Select
        value={locale}
        onChange={handleChange}
        options={LANGUAGE_OPTIONS}
        disabled={isLoading}
        getOptionValue={(opt) => opt.value}
        getOptionLabel={(opt) => opt.label}
        renderTrigger={(selected, isOpen, disabled) => (
          <button
            className="button-square"
            disabled={disabled}
            aria-label="Select language"
            aria-expanded={isOpen}
            type="button"
          >
            <span className="language-selector__flag">
              {selected?.flag || '\u{1F310}'}
            </span>
          </button>
        )}
        renderOption={(option, isSelected) => (
          <div className="language-selector__option">
            <span className="language-selector__option-flag">{option.flag}</span>
            <span className="language-selector__option-name">{option.label}</span>
            {isSelected && <span className="language-selector__option-check">✓</span>}
          </div>
        )}
      />
    </div>
  );
}
